import {pxToRem} from '../../../../utills/pxToRem'
import {fonts} from '../../../../theme/foundations/fonts'
import sizes from '../../../../theme/foundations/sizes'

const {md} = sizes.container

export const contentStyle = {
    boxSizing: 'border-box',
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: pxToRem(14),
    maxWidth: '100%',
    margin: '0 auto',
    [`@media (min-width: ${md})`]: {
        fontSize: pxToRem(16),
        maxWidth: pxToRem(1400),
        paddingBottom: pxToRem(20)
    },
    h1: {
        fontSize: pxToRem(24),
        textAlign: 'center',
        marginBottom: pxToRem(8),
        letterSpacing: pxToRem(3.3),
        margin: `${pxToRem(10)} 0`,
        [`@media (min-width: ${md})`]: {
            fontSize: pxToRem(25),
            letterSpacing: pxToRem(4.5),
            paddingTop: pxToRem(10),
            margin: `0 0 ${pxToRem(14)} 0`
        }
    },

    h2: {
        fontSize: pxToRem(28),
        margin: `${pxToRem(24)} 0`,
        letterSpacing: pxToRem(1),
        [`@media (min-width: ${md})`]: {
            fontSize: pxToRem(19),
            margin: `${pxToRem(16)} 0`
        }
    },
    h3: {
        fontSize: pxToRem(16),
        fontWeight: 700,
        letterSpacing: pxToRem(2.4),
        textTransform: 'uppercase',
        marginBlock: pxToRem(16),
        [`@media (min-width: ${md})`]: {
            fontSize: pxToRem(18),
            letterSpacing: pxToRem(2.7)
        }
    },
    p: {
        fontSize: pxToRem(14),
        letterSpacing: pxToRem(1.12),
        marginBlock: pxToRem(14),
        [`@media (min-width: ${md})`]: {
            fontSize: pxToRem(16),
            letterSpacing: pxToRem(1.28)
        }
    },
    ol: {
        marginBlock: pxToRem(16),
        paddingInline: pxToRem(24),
        li: {
            listStyle: 'decimal outside none',
            fontWeight: 400,
            letterSpacing: pxToRem(1.12),
            lineHeight: pxToRem(24),
            [`@media (min-width: ${md})`]: {
                letterSpacing: pxToRem(1.28)
            }
        }
    },

    td: {
        padding: pxToRem(14)
    },

    hr: {
        marginBlock: pxToRem(7)
    },

    '.button,button': {
        width: pxToRem(260),
        minHeight: pxToRem(35),
        padding: pxToRem(10),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'white',
        fontFamily: fonts.primary,
        fontSize: pxToRem(12),
        fontWeight: 700,
        lineHeight: pxToRem(13.5),
        letterSpacing: 1.44,
        testTransform: 'uppercase',
        background: 'cav_red',
        marginInline: 'auto',
        textDecoration: 'none',

        '&:hover': {
            transform: 'scale(1.05)'
        },

        [`@media (min-width: ${md})`]: {
            width: pxToRem(295),
            minHeight: pxToRem(40),
            padding: pxToRem(12),
            letterSpacing: 1.68,
            fontSize: pxToRem(14)
        }
    }
}
